import React from 'react';
import cn from 'classnames';
import styles from './CTARow.css';

import rightChevron from '../../images/chevron-right-blue.svg';
import { genKey } from '../../utils/addKey';
import { pushToNASU } from './util';

const CTARow = ({ BuyOptions, row }) => (
    <React.Fragment>
        {BuyOptions.map((option, index) => (
            <button
                className={cn({ row })}
                key={`cta-btn-${genKey()}`}
                id={`cta-btn-${index}`}
                onClick={() => pushToNASU(option.link)}
                type="button"
            >
                {option.title}
                <span className="cta-subtitle">{option.subtitle}</span>
                <img
                    className="cta-chevron-icon"
                    src={rightChevron}
                    alt="Buy ETFs Right Chevron"
                />
            </button>
        ))}
        <style jsx>{styles}</style>
    </React.Fragment>
);

export default CTARow;
